<ng-container *ngIf="archived; else defaultTmpl">
  <gtd-number-status [data]="0" [statusNames]="[statusNames[0]]"> </gtd-number-status>
</ng-container>
<ng-template #defaultTmpl>
  <gtd-number-status [data]="+status" [statusNames]="statusNames"> </gtd-number-status>
</ng-template>
